<select [(ngModel)]="tool.selectedClass" class="form-control">
  <option
    *ngFor="let keypointClass of tool.classes"
    [ngValue]="keypointClass"
    [label]="keypointClass.label"
  ></option>
</select>
